
$(function () {

    const $jours = $('#repitAjouterModalContent input[name="recurrence[days][]"]');
    const $weeks = $('#repitAjouterModalContent select[name="recurrence[weeks]"]');
    const $heure = $('#repitAjouterModalContent input[name="recurrence[heure]"]');
    const $finDateRadio = $('#repitAjouterModalContent #recurrenceDateFin');
    const $finNombreRadio = $('#repitAjouterModalContent #recurrenceNombreFin');
    const $finDate = $('#repitAjouterModalContent input[name="recurrence[fin][date]"]');
    const $finNombre = $('#repitAjouterModalContent input[name="recurrence[fin][nombre]"]');
    const $dateDebut = $('#repitAjouterModalContent input[name="date_debut"]');
    const $submit = $('#repitAjouterModalContent button[type="submit"]');
    const noRecurrenceText = $('#repitAjouterModalBtnWithRecurrenceTxt').text();

    const weekSelectModule = require("flatpickr/dist/plugins/weekSelect/weekSelect.js");
    const weekSelect = weekSelectModule.default || weekSelectModule;


    const $container_planning = $(".planning_table_content");
    const $cible = $("#tr_hour_12");

    if ($container_planning.length && $cible.length) {
        $container_planning.animate({
        scrollTop: $cible.position().top
        }, 500);
    }
    
    // select week > travailleurs planning
    $('#btn_select_week').on('click', function (e) {
        // je veux que ca ouvre le flatpickr en mode semaine dans select_week_input qui est hidden
        const fp = $('#select_week_input').flatpickr({
            plugins: [ new weekSelect({}) ],
            clickOpens: false,
            locale: {
                firstDayOfWeek: 1  // lundi
            },
            onChange: function() {

                const firstDay = this.selectedDates[0]; // 👈 le lundi de la semaine
                if (!firstDay) return;

                // format YYYY-MM-DD
                const formatted = this.formatDate(firstDay, "Y-m-d");

                console.log("Premier jour de la semaine :", formatted);

                // remplir ton input
                $('#week_number_input').val(formatted);

                // submit si besoin
                $('#planning_form_filters').submit();
            }
        });
        fp.open();
    });

    function calculerNombreRendezVous() {
        if ($('#isRecurrenceInput').val() != 1) {
            return;
        }
        const joursSelectionnes = $jours.filter(':checked').map(function () {
            return $(this).val();
        }).get();

        if (joursSelectionnes.length === 0) {
            // desactiver bouton submit
            $submit.prop('disabled', true);
            let text = noRecurrenceText;
            // remplacer [x] par 0
            text = text.replace('[x]', '0');
            $submit.text(text);
            return;
        }

        const everyXWeeks = parseInt($weeks.val() || 1);
        let total = 0;

        const dateDebutVal = $dateDebut.val();
        if (!dateDebutVal) {
            $submit.prop('disabled', true);
            let text = noRecurrenceText;
            // remplacer [x] par 0
            text = text.replace('[x]', '0');
            $submit.text(text);

            return;
        }

        const dateDebut = new Date(dateDebutVal);
        if (isNaN(dateDebut)) {
            $submit.prop('disabled', true);
            let text = noRecurrenceText;
            // remplacer [x] par 0
            text = text.replace('[x]', '0');
            $submit.text(text);
            return;
        }

        if ($finDateRadio.is(':checked')) {
            const dateFin = new Date($finDate.val());
            dateFin.setHours(23, 59, 59, 999); // inclut tout le jour de fin
            if (isNaN(dateFin)) {
                $submit.prop('disabled', true);
                let text = noRecurrenceText;
                // remplacer [x] par 0
                text = text.replace('[x]', '0');
                $submit.text(text);
                return;
            }

            let current = new Date(dateDebut);

            // console.log('Calcul des rendez-vous entre ' + dateDebut.toISOString().slice(0, 10) + ' et ' + dateFin.toISOString().slice(0, 10));
            // console.log('Jours sélectionnés : ' + joursSelectionnes.join(', '));

            let cptWeek = 0;
            // Je veux parcourir toutes les dates entre dateDebut et dateFin (inclus)et incrémenter le compteur en fonction des choix, je
            for (let d = new Date(dateDebut); d <= dateFin; d.setDate(d.getDate() + 1)) {
                const dayShort = d.toLocaleString('en-US', { weekday: 'short' }).toLowerCase().slice(0, 3);
                // si on est un lundi, on incrémente le compteur de semaine, sauf si c'est le premier jour
                if (dayShort === 'mon' && d.getTime() !== dateDebut.getTime()) {
                    cptWeek++;
                }

                if (joursSelectionnes.includes(dayShort)) {
                    if (cptWeek % everyXWeeks === 0) {
                        total++;
                    }
                }
                // console.log(d);
                // console.log(dateFin + 'Vérification DATE FIN du ' + d.toISOString().slice(0, 10) + ' (' + dayShort + '), total actuel : ' + total);
            }


        } else if ($finNombreRadio.is(':checked')) {
            total = $finNombre.val();
        }

        if (total > 0) {
            $submit.prop('disabled', false);
        } else {
            $submit.prop('disabled', true);
        }


        let text = noRecurrenceText;
        // remplacer [x] par 0
        text = text.replace('[x]', total);
        $submit.text(text);
    }

    // 🧩 Événements écoutés
    $jours.on('change', calculerNombreRendezVous);
    $weeks.on('change', calculerNombreRendezVous);
    $finDate.on('change input', calculerNombreRendezVous);
    $finNombre.on('change input', calculerNombreRendezVous);
    $finDateRadio.on('change', calculerNombreRendezVous);
    $finNombreRadio.on('change', calculerNombreRendezVous);
    $dateDebut.on('change input', calculerNombreRendezVous);

    // Premier calcul au chargement si #repitAjouterModalContent existe
    if ($('#repitAjouterModalContent').length) {
        calculerNombreRendezVous();
    }

    $(document).on("click", "#repitAjouterRecurrence", function () {
        $('#repitAjouterRecurrenceContainer').fadeIn();
        $('#repitAjouterRecurrence').hide();
        $('#isRecurrenceInput').val(1);
        calculerNombreRendezVous();
    });

    $(document).on("click", "#repitSupprimerRecurrence", function () {
        $('#repitAjouterRecurrenceContainer').hide();
        $('#repitAjouterRecurrence').fadeIn();
        $('#isRecurrenceInput').val(0);
        $('#repitAjouterModalContent button[type="submit"]').prop('disabled', false);
        $('#repitAjouterModalContent button[type="submit"]').text($('#repitAjouterModalBtnNoRecurrenceTxt').text());
    });



    $('#joursGroup .btn-day').on('click', function (e) {
        e.preventDefault(); // empêche le comportement Bootstrap "radio"
        const $btn = $(this);
        const $input = $btn.find('input[type="checkbox"]');

        // Toggle l'état actif
        const isActive = $btn.hasClass('active');
        $btn.toggleClass('active', !isActive);
        $input.prop('checked', !isActive);

        setTimeout(calculerNombreRendezVous, 50);
    });

    $(document).on("click", ".btnRemoveFile", function () {
        $($(this).data('input')).val(1);
        $($(this).data('hide')).hide();
        $('.btnRemoveFile').hide();
    });
    $(document).on("click", ".btnOpenFile", function () {
        $($(this).data('input')).trigger('click');
    });
    $(document).on("submit", '.ajaxForm', function (e) {
        e.preventDefault();
        $('#globalLoader').show();
        $.ajax({
            url: $(this).attr('action'),
            type: $(this).attr('method'),
            data: $(this).serializeArray(),
            success: function (response) {
                if (response.success) {
                    $('#alert-success').hide();
                    $('#alert-success span').html(response.success);
                    setTimeout(() => {
                        $('#alert-success').show();
                    }, 200);
                }
                try {
                    url = new URL(response.url);
                    if (url) {
                        window.location.href = url;
                    }
                } catch (_) {
                    if (response.ajax_update_html && response.ajax_update_id) {
                        $('#globalLoader').hide();
                        $('.modal').modal('hide');
                        $(response.ajax_update_id).fadeOut().html(response.ajax_update_html).fadeIn(300);
                    } else {
                        location.reload();
                    }
                }
            },
            error: function (response) {
                $('#globalLoader').hide();
                // console.log(response);
                // console.log(response.message);
                // console.log(response.responseJSON.message);
                if (response.responseJSON.message) {
                    $('.modalAjaxFormError').html(response.responseJSON.message).hide().fadeIn();
                } else {
                    if (response.responseJSON.error) {
                        $('.modalAjaxFormError').html(response.responseJSON.error).hide().fadeIn();
                    } else {
                        $('.modalAjaxFormError').html("Une erreur est survenue").hide().fadeIn();
                    }
                }
                $('.is-invalid').removeClass('.is-invalid');
                $('.invalid-feedback').hide();
                if (response.responseJSON.errors) {
                    Object.keys(response.responseJSON.errors).forEach(key => {
                        $('#' + key + '_error').html(response.responseJSON.errors[key]).fadeIn();
                        $('#' + key).addClass('is-invalid');
                    });
                }
                if (response.errors) {
                    Object.keys(response.errors).forEach(key => {
                        $('#' + key + '_error').html(response.errors[key]).fadeIn();
                        $('#' + key).addClass('is-invalid');
                    });
                }
            },
        });
    });
    if ($('#locomotion_moyen')) {
        if ($('#locomotion_moyen').val() == 'bus' || $('#locomotion_moyen').val() == 'velo' || $('#locomotion_moyen').val() == 'apied') {
            $('#input_modele_couleur').hide();
        } else {
            $('#input_modele_couleur').show();
        }
    }
    $(document).on("change", '#locomotion_moyen', function (e) {
        if (this.value == 'bus' || this.value == 'velo' || this.value == 'apied') {
            $('#input_modele_couleur').hide();
        } else {
            $('#input_modele_couleur').show();
        }
    });
    $('.inputFilePhoto').on('change', function (e) {
        var remove = $(this).data('remove');
        var max = $(this).data('max');
        if (typeof max !== 'undefined') {
            // console.log(this.files[0].type);
            if (this.files[0].size > max) {
                alert("Le fichier est trop volumineux");
                this.value = "";
            } else if (this.files[0].type != 'image/jpeg' && this.files[0].type != 'image/png') {
                alert("Le fichier doit être une image (jpg ou png)");
                this.value = "";
            } else {
                if (typeof remove !== 'undefined') {
                    $($(this).data('remove')).val(0);
                    setBase64(this.files[0], $($(this).data('img')), $($(this).data('show')));
                    // $($(this).data('show')).show();
                }
            }
        }
    });
    $('.documentFileEdit').on('click', function (e) {
        e.preventDefault();
        var id = $(this).data('id');
        if (typeof id !== 'undefined') {
            $(id).find('.documentFileEdit').hide();
            $(id).find('.documentFileNameTxt').hide();
            $(id).find('.documentFileName').removeClass('d-none');
        }
    });

    $('.documentFileRemove').on('click', function (e) {
        e.preventDefault();
        var id = $(this).data('id');
        if (typeof id !== 'undefined') {
            $($(this).data('remove')).val(0);
            $(id).find('.documentFileRemove').val(1);
            $(id).hide();
        }
    });

    $('#addProcheAidant').on('click', function (e) {
        e.preventDefault();
        $('#listProchesAidants').append($('#elProcheAidantNew').html());
        $('#listProchesAidants .select2PA').select2();
    });

    $('.removeProcheAidant').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.elProcheAidant').find('.inputRemoveProcheAidant').val(1);
        $(this).closest('.elProcheAidant').fadeOut();
    });

    $(document).on('click', '.removeProcheAidantNew', function (e) {
        e.preventDefault();
        $(this).closest('.elProcheAidantNew').fadeOut().remove();
    });
    $('.formIPAideEdit').on('submit', function (e) {
        $('#elProcheAidantNew').remove();
    });

    // Sélecteur MRC / Secteurs
    $(document).on('change', '.selectMrc', function (e) {
        var mrc_id = $(this).val();
        if ($(this).is(':checked')) {
            $('.selectSecteur-' + mrc_id).prop('checked', true);
        } else {
            $('.selectSecteur-' + mrc_id).prop('checked', false);
        }
        $('#mrc-' + mrc_id).removeClass('middle-checked');
        var checked = $('.selectSecteur-' + mrc_id + ':checked').length;
        $('.countSecteur-' + mrc_id).html(checked);
        $('#mrcSecteurs-' + mrc_id).css('display', 'flex');
    });

    $(document).on('change', '.selectSecteur', function (e) {
        var mrc_id = $(this).data('mrc');
        var checked = $('.selectSecteur-' + mrc_id + ':checked').length;
        $('.countSecteur-' + mrc_id).html(checked);
        // si nombre de secteurs cochés atteint le nombre de secteurs total alors on coche la MRC
        if (checked == $('.selectSecteur-' + mrc_id).length) {
            $('#mrc-' + mrc_id).prop('checked', true);

        } else {
            $('#mrc-' + mrc_id).prop('checked', false);
        }
        // si au moins un secteur est coché mais pas tous alors on ajoute la classe middle-checked à la checkbox de la MRC sinon on l'enleve
        if (checked > 0 && checked < $('.selectSecteur-' + mrc_id).length) {
            $('#mrc-' + mrc_id).addClass('middle-checked');
        } else {
            $('#mrc-' + mrc_id).removeClass('middle-checked');
        }

    });

    $(document).on('click', '.toggleSecteurs', function (e) {
        var div = $('#' + $(this).data('mrc'));

        div.toggle();

        if ($(this).find('.bi').hasClass('bi-chevron-right')) {
            $(this).find('.bi').removeClass('bi-chevron-right').addClass('bi-chevron-down');
        } else {
            $(this).find('.bi').removeClass('bi-chevron-down').addClass('bi-chevron-right');
        }
    }
    );

    $(document).on('submit', '.contactMaisonRepitForm', function (e) {
        e.preventDefault();
        var $form = $(this);
        $('#globalLoader').show();
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function (response) {
                $('#globalLoader').hide();
                $form.closest('.modal').modal('hide');
                if (response.success) {
                    $('#alert-success').hide();
                    $('#alert-success span').html(response.success);
                    setTimeout(() => {
                        $('#alert-success').show();
                    }, 200);
                }
            },
            error: function () {
                $('#globalLoader').hide();
                alert("Une erreur est survenue, veuillez réessayer.");
            },
        });
    });


});

function setBase64(file, target, show) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        //   console.log(reader.result);
        target.attr('src', reader.result);
        show.show();
    };
    reader.onerror = function (error) {
        // console.log('Error: ', error);
    };
}
